// extracted by mini-css-extract-plugin
module.exports = {"loginTypeGroup":"Auth_loginTypeGroup__ni82D","loginType":"Auth_loginType__E_4P2","active":"Auth_active__NAe7d","nextIcon":"Auth_nextIcon__2-lBu"};